import { render, staticRenderFns } from "./profileNetworks.vue?vue&type=template&id=10c1d444&scoped=true&"
import script from "./profileNetworks.vue?vue&type=script&lang=js&"
export * from "./profileNetworks.vue?vue&type=script&lang=js&"
import style0 from "./profileNetworks.vue?vue&type=style&index=0&id=10c1d444&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c1d444",
  null
  
)

export default component.exports